export default __webpack_public_path__ + "static/cardImg4-adadb469f87d4a2d2162ec37366c9f0a.webp";